var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 532 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736",
    transform: "translate(-5151.469 134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    "data-name": "Path 4343",
    d: "M350,14C203.34,14,84,133.34,84,280S203.34,546,350,546,616,426.66,616,280,496.66,14,350,14Zm6.441,503.89V449.851c0-49.5-40.266-90.047-89.77-90.441-11.312-.055-21.672-.281-30.016-.672-8.961-.391-44.855-23.578-122.98-107.13C127.73,133.728,228.365,42,350,42a236.943,236.943,0,0,1,160.38,62.328L455.1,127.006a16.458,16.458,0,0,1-6.383,1.289H422.232a45.333,45.333,0,0,0-44.969,41.328l-3.75,43.68a17.393,17.393,0,0,1-10.922,14.559l-5.488,2.184a45.164,45.164,0,0,0,16.578,87.191l72.8-2.465A38.732,38.732,0,0,1,486.52,352.46l.84,32.984A45.392,45.392,0,0,0,501.192,416.8l24.527,23.578a237.545,237.545,0,0,1-169.29,77.508Z",
    transform: "translate(5067.469 -148)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoFilter);
export default __webpack_public_path__ + "static/media/co_filter.f5d8c42040ea130978496ca53b1f96bd.svg";
export { ForwardRef as ReactComponent };